const LOCALES_ES = {
  about: 'Sobre Nosotros',
  services: 'Servicios',
  contacts: 'Contactos',
  news: 'Noticias',
  followUs: 'Síguenos en ',
  goBack: 'Regresar',
  pageNotFound: 'Página No Encontrada',
};

export default LOCALES_ES;
